<timepicker
    [(ngModel)]="innerValue"
    [showMeridian]="false"
    [arrowkeys]="true"
    [showSpinners]="false"
    [hourStep]="1"
    [minuteStep]="10"
    (blur)="onBlur()">
</timepicker>
